export function findFirstPosition(arr: number[], val: number) {
  for (let i = 1; i < arr.length; i++) {
    if (arr[i] >= val) {
      return i - 1;
    }
  }
  return arr.length - 1;
}
